(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  var searchInput = document.querySelector('#search-modal input[type="search"]');
  if (searchInput) {
    searchInput.setAttribute('placeholder', 'What are you looking for?');
  }
});
  } catch(e) { console.error(e); }
})();

})();
